import { convertFromRaw, convertToRaw, EditorState } from 'draft-js';
import PropTypes from 'prop-types';
import React from 'react';
//import { ENTITY_TYPE } from 'draft-js-utils';
//import { EditorState, Modifier } from 'draft-js';
import 'react-confirm-alert/src/react-confirm-alert.css';
import MathJax from '../component/react-mathjax-preview';
import { Button, Cell, Grid, TextField } from 'react-md';
import { NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import ApiRequestService from '../component/ApiRequestService';
import ImageResizeWarning from '../component/ImageResizeWarning';
import Loader from '../component/Loader';
import LoadingSpinner from '../component/LoadingSpinner';
import SelectBox from '../component/SelectBox';
import TextEditor from '../component/TextEditor';
import '../css/common.css';
import '../css/createExplanations.css'; ///bug-tracker#156
import '../css/custom.css';
import '../css/index.css';
import '../css/mediaCss.css';
import styles from '../css/styles.css.js';
import { AppProperties } from '../common/function';
import { DialogContainer, NavigationDrawer } from "react-md";
import { Button as SFButton } from '@mui/material'
import SFExplanationPreview from './SFExplanationPreview';


//let RichTextEditor = null;
const testString = String.raw`When $a \ne 0$, there are two solutions to \(ax^2 + bx + c = 0\) and they are
$$x = {-b \pm \sqrt{b^2-4ac} \over 2a}.$$`;
//let answerIndex = 0;

export default class CreateExplanations extends React.Component {
  appProperties = AppProperties();
  static propTypes = {
    onChange: PropTypes.func
  };

  constructor(props) {
    super(props);

    this.state = {
      ExplanationText: '',
      pageLoading: true,
      ///bug-tracker#156
      showSubCategorySelectBox: true,
      showTopicsSelectBox: true,
      showCategorySelectBox: true,
      style: this.props.style,
      styleans1: this.props.style,
      math: testString,
      isExplanationWithPreview: false,
      selectBoxTopicValue: '',
      selectBoxCategoryValue: '',
      selectBoxSubCategoryValue: '',
      subjects: [],
      topics: [],
      categories: [],
      subCategories: [],
      subjectId: this.props.selectedSubjectId,
      topicId: this.props.selectedTopicId,
      categoryId: this.props.selectedCategoryId,
      subcategoryId: this.props.selectedSubCategoryId,
      /*
      subjectId: 0,
      topicId: 0,
      categoryId: 0,
      subcategoryId: 0,*/
      ExplanationName: '',
      loading: true,
      Explanations: [],
      ExplanationNameDefaultVaule: '',
      subjectDefaultId: 0,
      topicDefaultId: 0,
      categoryDefaultId: 0,
      subCategoryDefaultId: 0,
      defaultExplanationText: '',
      explanationText: '',
      saveButtonShow: true,
      loadingSave: false,
      ExplanationNonGraded: 0,
      altExplanationTextVisible:false,
      altExplanationText:'',
      imgTagCount:0,
      showLivePreview: false
    };
    if (this.props.copyMode === 1) {
      this.state.copyMode = 1;
    }
    if ((this.appProperties.enableLTI) ) {
      this.props.readOnly = true
    }
    if (this.props.moveMode === 1) {
      this.state.moveMode = 1;
    }

    this.onExplanationTextChange = this.onExplanationTextChange.bind(this);
    this.previewExplanation = this.previewExplanation.bind(this);
    this.previewExit = this.previewExit.bind(this);
    this.selectBoxSubjectHandleChange = this.selectBoxSubjectHandleChange.bind(
      this
    );
    this.selectBoxTopicHandleChange = this.selectBoxTopicHandleChange.bind(
      this
    );
    this.selectBoxCategoryHandleChange = this.selectBoxCategoryHandleChange.bind(
      this
    );
    this.selectBoxSubcategoryHandleChange = this.selectBoxSubcategoryHandleChange.bind(
      this
    );
    this.changeExplanationName = this.changeExplanationName.bind(this);
    this.selectBoxMultipleChoiceHandleChange = this.selectBoxMultipleChoiceHandleChange.bind(
      this
    );
    this.addExplanation = this.addExplanation.bind(this);
    this.copyExplanation = this.copyExplanation.bind(this);
    this.loadTopicData = this.loadTopicData.bind(this);
    this.onLoadResponse = this.onLoadResponse.bind(this);
    this.onDisplayStyleChange = this.onDisplayStyleChange.bind(this);

  }

  //bug-tracker#261
  onDisplayStyleChange(value){
    console.log('event',value);
  }


  onLoadResponse(res) {
    console.debug('res.data.data.Explanations = ', res.data.data);

    if (res.data.data !== null) {
      console.debug('IN IF CONDITION = ', res.data.data);
      var tempExplanationNameDefaultVaule = res.data.data.Explanation_name;
      var tempSubjectDefaultId = parseInt(res.data.data.subject_id, 10);
      var tempTopicDefaultId = parseInt(res.data.data.topic_id, 10);
      var tempCategoryDefaultId = parseInt(res.data.data.category_id, 10);
      var tempSubCategoryDefaultId = parseInt(res.data.data.subcategory_id, 10);
      var tempExplanationTextDefaultId = res.data.data.text;

      this.setState({
        Explanations: res.data.data,
        ExplanationNameDefaultVaule: tempExplanationNameDefaultVaule,
        subjectDefaultId: tempSubjectDefaultId,
        topicDefaultId: tempTopicDefaultId,
        categoryDefaultId: tempCategoryDefaultId,
        subCategoryDefaultId: tempSubCategoryDefaultId,
        altExplanationTextEditorObj: res.data.data.alt_explantion_text,
        ExplanationTextEditorObj: TextEditor.createValueFromString(
          tempExplanationTextDefaultId,
          'html'
        )
      });


    }


    this.setState({
      loading: false,
      saveButtonShow: true
    });
  }

  loadSubjectData() {
    //let answerIndex = 0;
    ApiRequestService({
      method: 'post',
      url: '/getAllSubjects'
    }).then(res => {
      //console.debug(res.data.data.subject_names);
      this.setState({
        subjects: res.data.data.subject_names
      });
    });
  }

  componentWillMount() {
    // asyncComponent(() => import("react-mathjax-preview"));
    //Promise.all([import('react-rte'), import('react-mathjax-preview')]).then(
    //([reactRte, mathjax]) => {
    //Loading React RTE Module On Demand

    // console.debug('componentWillMount');
    var sub_id = parseInt(this.props.selectedSubjectId, 10);
    var top_id = parseInt(this.props.selectedTopicId, 10);
    var catg_id = parseInt(this.props.selectedCategoryId, 10);
    

    var explanation_name = this.props.selectedExplanationName;
    // console.debug("begininig ",this.props.selectedExplanationText)
    var explanation_text = this.props.selectedExplanationText;
    var alt_explanation_text =  this.props.selectedAltExplanationText;
    if(explanation_text !== undefined && explanation_text !== null && explanation_text !== ""){
      const contentState = convertFromRaw( JSON.parse( explanation_text) );
      // console.log("contentState",contentState);
      const serlializedState  = EditorState.createWithContent(contentState);
      // console.log("editorstate ",serlializedState)
      this.setState({
        loading: false,
        ExplanationNameDefaultVaule: explanation_name,
        ExplanationName:explanation_name,
        ExplanationTextEditorObj: serlializedState,
        pageLoading: false,
        altExplanationTextEditorObj:alt_explanation_text
      });
    }
    else{
      this.setState({
        loading: false,
        ExplanationNameDefaultVaule: explanation_name,
        ExplanationTextEditorObj: TextEditor.createEmptyValue(),
        altExplanationTextEditorObj: "",
        pageLoading: false
      });
    }

console.debug(alt_explanation_text)


    if (this.state.copyMode) {
      this.loadSubjectData();
      this.loadTopicData(sub_id);
      this.loadCategory(sub_id, top_id);
      this.loadSubcategory(sub_id, top_id, catg_id);
    }
    //}
    //);
  }

  componentDidUpdate(prevProps, prevState) {
    console.debug("prevProps", prevProps)
    if (
      prevProps.selectedExplanationId !== this.props.selectedExplanationId
    ) {
      var sub_id = parseInt(this.props.selectedSubjectId, 10);
      var top_id = parseInt(this.props.selectedTopicId, 10);
      var catg_id = parseInt(this.props.selectedCategoryId, 10);
      

      var explanation_name = this.props.selectedExplanationName;
      // console.debug("begininig ",this.props.selectedExplanationText)
      var explanation_text = this.props.selectedExplanationText;
      var alt_explanation_text =  this.props.selectedAltExplanationText;
      if(explanation_text !== undefined && explanation_text !== null && explanation_text !== ""){
        const contentState = convertFromRaw( JSON.parse( explanation_text) );
        // console.log("contentState",contentState);
        const serlializedState  = EditorState.createWithContent(contentState);

        // console.log("editorstate ",serlializedState)
        this.setState({
          loading: false,
          ExplanationNameDefaultVaule: explanation_name,
          ExplanationName:explanation_name,
          ExplanationTextEditorObj: serlializedState,
          pageLoading: false,
          altExplanationTextEditorObj:alt_explanation_text,
        });
      }
      else{
        this.setState({
          loading: false,
          ExplanationNameDefaultVaule: explanation_name,
          ExplanationTextEditorObj: TextEditor.createEmptyValue(),
          altExplanationTextEditorObj: "",
          pageLoading: false
        });
      }
    }
    
  }

  onExplanationTextChange = value => {
    this.setState({ ExplanationTextEditorObj: value });
    /*let html = stateToHTML(value.getCurrentContent());
    console.log("Final HTML=",html);



    const rawDraftContentState = JSON.stringify(convertToRaw(value.getCurrentContent()));


    const rawDraftContentState = JSON.stringify(convertToRaw(value.getCurrentContent()));
    console.log("rawDraftContentState", rawDraftContentState);
    const contentState = convertFromRaw( JSON.parse( rawDraftContentState) );
    console.log("contentState",contentState);
    const serlializedState  = EditorState.createWithContent(contentState);
    console.log("serlializedState", serlializedState);*/
    let enteredString = TextEditor.getHTMLStringFromEditorState(value);
    // console.debug(enteredString.toString());
    if (enteredString !== null) {
      this.setState({ ExplanationText: enteredString });
    }
    // console.debug(enteredString)
    var imgTagCount = enteredString.split('<img ').length-1
    console.debug(imgTagCount)
    if(imgTagCount >= 1){
      this.setState({
        altExplanationTextVisible : true,
        imgTagCount : imgTagCount
      })
    }
    if(imgTagCount < 1){
      this.setState({
        altExplanationTextVisible : false,
        //altExplanationTextEditorObj :'',
        imgTagCount : imgTagCount
      })
    }
      /*const serlializedString = TextEditor.getHTMLStringFromEditorState(serlializedState);
      console.log("serlializedString", serlializedString);
      if( serlializedString !== enteredString){
        console.log("serlializedString is different");
      }
      else{
        console.log("serlializedString is same");

      }*/
    
    //console.debug("props onChange ="+this.props.onChange);
    if (this.props.onChange) {
      this.props.onChange(enteredString);
    }
  };
  onAltExplanationTextChange = value => {
    this.setState({ altExplanationTextEditorObj: value });
    console.debug("value =  ", value);
    let enteredString = this.state.altExplanationTextEditorObj
    console.debug(enteredString);
    if (enteredString !== null) {
      this.setState({ altExplanationText: enteredString });
    }
  };
  selectBoxSubjectHandleChange(event) {
    // console.debug( "selectBoxSubjectHandleChange =",event.target.value);
    //this.setState({selectBoxTopicValue: event.target.value});

    var sub_id = parseInt(event.target.value, 10);
    this.setState({
      subjectId: sub_id,
      showTopicsSelectBox: false,
      showCategorySelectBox: false,
      showSubCategorySelectBox: false,
      topicId: null,
      categoryId: null,
      subcategoryId: null,
      topicDefaultId: 0
    });

    this.loadTopicData(sub_id);
  }

  loadTopicData(sub_id) {
    //console.debug("loadTopicData");
    this.setState({ subjectId: sub_id });
    var tempTopic = [];
    const payload = {
      // subject_id: this.state.subject_id
      subject_id: sub_id
    };
    //console.debug("Subject id : ",payload);
    ApiRequestService({
      method: 'post',
      url: '/getAllTopics',
      data: payload
    }).then(res => {
      console.debug('topic res=', res.data.data.topic_names);

      if (res.data.data.topic_names !== null) {
        tempTopic = res.data.data.topic_names;
        this.setState({
          topics: tempTopic,
          showTopicsSelectBox: true
        });
        //this.selectBoxTopicHandleChange(this.createFakeEvent(tempTopic[0].topic_id));
      } else {
        this.setState({
          topics: []
        });
        // this.selectBoxTopicHandleChange(this.createFakeEvent(-1));
      }
    });
  }
  selectBoxTopicHandleChange(event) {
    console.debug('selectBoxTopicHandleChange =', event.target.value);
    this.setState({
      showCategorySelectBox: false,
      showSubCategorySelectBox: false,
      categoryId: null,
      subcategoryId: null,
      categoryDefaultId: 0
    });
    var sub_id = parseInt(this.state.subjectId, 10);
    var top_id = parseInt(event.target.value, 10);
    this.loadCategory(sub_id, top_id);
  }
  createFakeEvent(id) {
    var fakeEvent = {};
    fakeEvent['target'] = {};
    fakeEvent.target.value = id;
    return fakeEvent;
  }

  loadCategory(sub_id, top_id) {
    this.setState({ topicId: top_id });
    const payload = {
      topic_id: top_id,
      subject_id: sub_id
    };
    //console.debug("Topic id : ",payload);
    ApiRequestService({
      method: 'post',
      url: '/getAllCategories',
      data: payload
    }).then(res => {
      console.debug('Get All Categories res :', res.data.data.category_names);
      if (res.data.data.category_names !== null) {
        this.setState({
          categories: res.data.data.category_names,
          showCategorySelectBox: true
        });

        //this.selectBoxCategoryHandleChange(this.createFakeEvent(res.data.data.category_names[0].category_id));
      } else {
        this.setState({
          categories: []
        });
        // this.selectBoxCategoryHandleChange(this.createFakeEvent(-1));
      }
    });
  }
  selectBoxCategoryHandleChange(event) {
    //console.debug( "selectBoxCategoryHandleChange =",event.target.value);

    var sub_id = parseInt(this.state.subjectId, 10);
    var top_id = parseInt(this.state.topicId, 10);
    var cat_id = parseInt(event.target.value, 10);
    this.setState({
      showSubCategorySelectBox: false,
      subcategoryId: null,
      subCategoryDefaultId: 0
    });
    this.loadSubcategory(sub_id, top_id, cat_id);
  }

  loadSubcategory(sub_id, top_id, cat_id) {
    this.setState({ categoryId: cat_id });
    const payload = {
      topic_id: top_id,
      subject_id: sub_id,
      category_id: cat_id
    };

    ApiRequestService({
      method: 'post',
      url: '/getAllSubCategories',
      data: payload
    }).then(res => {
      //console.debug("Get All SubCategories res :",res.data.data.subCategory_names);
      if (res.data.data.subCategory_names !== null) {
        this.setState({
          subCategories: res.data.data.subCategory_names,
          showSubCategorySelectBox: true
        });
      } else {
        this.setState({
          subCategories: []
        });
      }
    });
  }
  selectBoxSubcategoryHandleChange(event) {
    this.setState({ subcategoryId: parseInt(event.target.value, 10) });
  }
  selectBoxMultipleChoiceHandleChange(event) {
    //console.debug( "selectBoxMultipleChoiceHandleChange =",event.target.value);
    var tempMultipleChoice = parseInt(event.target.value, 10);
    tempMultipleChoice = event.target.value;

    this.setState({ multipleChoice: tempMultipleChoice });
    //console.debug("this.state.multipleChoice =", this.state.multipleChoice);
  }

  previewExplanation() {
    ////console.debug("test preview");
    var isExplanationWithPreview = true;
    this.setState({ isExplanationWithPreview: isExplanationWithPreview });
  }
  previewExit() {
    var isExplanationWithPreview = false;
    this.setState({ isExplanationWithPreview: isExplanationWithPreview });
  }


  /*
    Function to Delete explanation, this will be called when Move explanation is Clicked, to Delete the Old explanation

  */
  async deleteExplanation(
    subjectId,
    topicId,
    categoryId,
    subcategoryId,
    ExplanationId
  ) {
    const payload = {
      subject_id: subjectId,
      topic_id: topicId,
      category_id: categoryId,
      subcategory_id: subcategoryId,
      Explanation_id: ExplanationId
    };

    let response = await ApiRequestService({
      method: 'post',
      url: '/deleteExplanations',
      data: payload
    });

    console.log('response', JSON.stringify(response));
  }
  /**
    Copy explanation
  */

  copyExplanation(close) {
    this.setState({
      loadingSave: true,
      saveButtonShow: false
    });

    console.debug('Copy explanation');
    var sub_id = parseInt(this.state.subjectId, 10);
    var top_id = parseInt(this.state.topicId, 10);
    var cat_id = parseInt(this.state.categoryId, 10);
    var subcat_id = parseInt(this.state.subcategoryId, 10);

    var ExplanationName = this.state.ExplanationNameDefaultVaule;
    if (!this.isValidData(sub_id, top_id, cat_id)) {
      //If the Data is not valid, return, dont save
      this.setState({
        loading: false,
        saveButtonShow: true,
        loadingSave: false
      });
      return;
    }
    /*
     Fix for -  The “duplicate Explanation” feature does not save the explanation in the correct place. It should save the explanation in the same category and subcategory it was created. I am not even sure where it currently saves the explanation, but it is ot in the subcategory were the orginal explanation exists. This is high priority.
    */

    if (
      this.props.selectedSubjectId === this.state.subjectId &&
      this.props.selectedTopicId === this.state.topicId &&
      this.props.selectedCategoryId === this.state.categoryId &&
      this.props.selectedSubCategoryId === this.state.subcategoryId
    ) {
      if (
        this.state.ExplanationName === undefined ||
        this.state.ExplanationName === null ||
        this.state.ExplanationName === this.state.ExplanationNameDefaultVaule ||
        this.state.ExplanationName === ''
      ) {
        ExplanationName = 'Copy ' + this.state.ExplanationNameDefaultVaule;
        this.setState({
          ExplanationNameDefaultVaule:
            'Copy ' + this.state.ExplanationNameDefaultVaule
        });
      }
    }

    console.debug(
      'this.state.ExplanationNameDefaultVaule',
      this.state.ExplanationNameDefaultVaule
    );
    const payload = {
      subject_id: sub_id,
      topic_id: top_id,
      category_id: cat_id,
      subcategory_id: subcat_id,
      Explanation_name: ExplanationName
    };
    ApiRequestService({
      method: 'post',
      url: '/addExplanation',
      data: payload
    }).then(res => {
      if (res.data !== undefined && res.data !== null) {
        if (res.data.data !== undefined && res.data.data !== null) {
          this.addExplanation(
            res.data.data.Explanation_id,
            this.state.subjectId,
            this.state.topicId,
            this.state.categoryId,
            this.state.subcategoryId,
            close
          );

        } else if (
          res.data.message !== undefined &&
          res.data.message !== null
        ) {
          //bug-tracker#154
          console.error(res.data.message);

          NotificationManager.error(
            'Duplicate explanation',
            'Cannot create explanation with Name "' +
              this.state.ExplanationNameDefaultVaule +
              '"',
            5000
          );
          this.setState({
            loadingSave: false //Show Savw Button again on - Duplicate Questin Error
          });
        }
      }
    });
  }

  /*
  End Copy explanation
  */

  //Moving Validation to a common function so that they can be used on both copy and edit explanation.
  //bug-tracker#156
  //Returns true if Data is Valid
  isValidData(subjectId, topicId) {
    if (
      isNaN(subjectId) ||
      subjectId === undefined ||
      subjectId === null ||
      subjectId === '' ||
      subjectId === 0
    ) {
      NotificationManager.error(
        'Subject cannot be Empty, please select a subject'
      );
      return false;
    }

    if (
      isNaN(topicId) ||
      topicId === undefined ||
      topicId === null ||
      topicId === '' ||
      topicId === 0
    ) {
      NotificationManager.error('Topic Cannot be Empty, please select a topic');
      return false;
    }


    //Validate explanation Name as well.
    var ExplanationName = this.state.ExplanationNameDefaultVaule;
    if (
      ExplanationName === undefined ||
      ExplanationName === null ||
      ExplanationName === '' ||
      ExplanationName === 0
    ) {
      NotificationManager.error(
        'explanation Name cannot be Empty, please enter a valid explanation Name'
      );
      return false;
    }

    return true;
  }

  addExplanation(ExplanationID, subjectId, topicId, categoryId, subcategoryId, close) {
    if (!this.isValidData(subjectId, topicId)) {
      //If the Data is not valid, return, dont save
      this.setState({
        loading: false,
        saveButtonShow: true,
        loadingSave: false
      });
      return;
    }
    let tempExplanationText = TextEditor.getHTMLStringFromEditorState(this.state.ExplanationTextEditorObj);
    if (
      (this.state.ExplanationText === '' &&
      tempExplanationText === '') ||
      tempExplanationText === '<p><br></p>'
    ) {
      alert('Please enter the vaild "explanation text"');
      this.setState({
        loading: false,
        saveButtonShow: true,
        loadingSave: false
      });
      return false;
    }

    //checking alt question text
    console.debug("imgcount ",this.state.imgTagCount,this.state.altExplanationTextEditorObj)
    if(this.state.imgTagCount >= 1){
      let tempaltExplanationTextEditorObj = this.state.altExplanationTextEditorObj
      tempaltExplanationTextEditorObj = tempaltExplanationTextEditorObj.replace(/\n/ig, '')
      tempaltExplanationTextEditorObj = tempaltExplanationTextEditorObj.replace(/ /g,'')
      let attrTextArr = tempaltExplanationTextEditorObj.split(';')
      //removing empty array
      attrTextArr = attrTextArr.filter(function (el) {
        return el !== "";
      });
      console.debug(attrTextArr)
      var attrTextCount = attrTextArr.length
     console.debug(tempaltExplanationTextEditorObj," ",(attrTextCount%2)," ",this.state.imgTagCount," === ",(attrTextCount/2),"  ",attrTextCount)
      if(tempaltExplanationTextEditorObj === ''){
      alert('"Title and Alternative Text for all Images in Explanation" is Empty. Please enter a valid text.');
      this.setState({
        loading: false,
        saveButtonShow: true,
        loadingSave: false
      });
      return false;
    }
    if((attrTextCount%2) !== 0){
      alert('Title or Alternative text is missing in "Title and Alternative Text for all Images in Explanation"');
      this.setState({
        loading: false,
        saveButtonShow: true,
        loadingSave: false
      });
      return false;
    }

    if(this.state.imgTagCount !== (attrTextCount/2)){
      alert('Please enter a valid text for all images in "Title and Alternative Text for all Images in Explanation"');
      this.setState({
        loading: false,
        saveButtonShow: true,
        loadingSave: false
      });
      return false;
    }
    var lastChar = tempaltExplanationTextEditorObj[tempaltExplanationTextEditorObj.length -1];
    console.debug("last char ",lastChar)
    if(lastChar === ";"){
      alert('Please remove semicolon at the end of the text in "Title and Alternative Text for all Images in Question"');
      this.setState({
        loading: false,
        saveButtonShow: true,
        loadingSave: false
      });
      return false;
    }
  }
    //checking alt question text

    this.setState({
      //loading: true,
      saveButtonShow: false,
      loadingSave: false
    });

    //this.setState({ loading: true })

    console.debug('add explanation :');
    var sub_id = subjectId;
    var top_id = topicId;
    var cat_id = categoryId;
    var subCat_id = subcategoryId;

    console.debug('add explanation subjectId =', subjectId);
    console.debug('add explanation topicId =', topicId);
    console.debug('add explanation categoryId =', categoryId);
    console.debug('add explanation subcategoryId =', subcategoryId);
    //if (this.state.subcategoryId === 0) {
    //subCat_id = parseInt(this.state.subCategoryDefaultId,10);
    // }

    var Explanation_name = '';
    if (this.state.ExplanationName !== '') {
      Explanation_name = this.state.ExplanationName;
    } else {
      Explanation_name = this.state.ExplanationNameDefaultVaule;
    }


    var explanation_text = TextEditor.getHTMLStringFromEditorState(this.state.ExplanationTextEditorObj);
    this.setState(
      {
        explanationText : explanation_text,
        altExplanationText : this.state.altExplanationTextEditorObj
      }
    );
//console.debug("this is before rawdata ",explanation_text)
    const rawDraftContentState = JSON.stringify(convertToRaw(this.state.ExplanationTextEditorObj.getCurrentContent()));
//console.debug("this is rawdata ",rawDraftContentState)
    const payload = {
      explanation_id: ExplanationID,
      topic_id: top_id,
      subject_id: sub_id,
      category_id: cat_id,
      subcategory_id: subCat_id,
      explanation_name: Explanation_name,
      text: rawDraftContentState,
      alt_explanation_text : this.state.altExplanationTextEditorObj
    };
    this.setState({
      ExplanationID: ExplanationID,
      loadingSave: true
    });
    console.debug('payload', payload);
    ApiRequestService({
      method: 'post',
      url: '/updateExplanation',
      data: payload
    }).then(res => {
      // console.debug("res------>",res)
      if (res && res.data && res.data.data === null && res.data.message) {
        NotificationManager.error(res.data.message, "Error", 5000);
        return;
      }
      console.debug('update explanation Response : ', res);
      // this.state.topics.push({
      //       topic_name: res.data.data.topic_name,
      //       topic_id:   res.data.data.topic_id
      // });
      // this.setState({
      //     topics: this.state.topics
      // })
      this.props.onUpdate(this.props.selectedIndex, rawDraftContentState, this.state.altExplanationTextEditorObj);

      //If the Move Option has been Selected, then Call Delete Function to Delete the Original explanation
      if (this.state.moveMode === 1) {
        //subjectId,topicId,categoryId,subcategoryId,ExplanationId
        this.deleteExplanation(
          this.props.selectedSubjectId,
          this.props.selectedTopicId,
          this.props.selectedCategoryId,
          this.props.selectedSubCategoryId,
          this.props.selectedExplanationId
        );
      }

      //bug id 150 fixes
      NotificationManager.success('Saved successfully!', 'Success');
      if (this.state.copyMode === 1) {
        this.createRedirectURL(); //bug-tracker#69
        this.setState({ copyMode: 0, moveMode: 0, loading: false },()=>{
          if(close === true){
            this.props.close();
          }
        });
      }else{
        if(close === true){
          this.props.close(payload);
        }
      }
      if(close !== true){
        //this.onLoadResponse(res);
      }
      //this.props.hidemodule(res,this.props.selectedIndex)
    }).finally(() => {
      this.setState({ loadingSave: false });
    });
  }

  //GetNamesForRedirect - Get Names of Subject ,Topic , Category  and Subcategory , given their IDs
  //bug-tracker#69
  getNamesForRedirect(payload) {
    return ApiRequestService({
      method: 'post',
      url: '/getNamesForRedirect',
      data: payload
    });
  }
  //bug-tracker#69
  async createRedirectURL() {
    if (this.props.copyMode === 1) {
      this.setState({ loading: true });

      const payload = {
        ExplanationID: this.state.ExplanationID,
        categoryID: this.state.categoryId,
        topicID: this.state.topicId,
        subjectID: this.state.subjectId
      };
      console.log('this.state.subcategoryId', this.state.subcategoryId);

      if (
        this.state.subcategoryId !== undefined &&
        this.state.subcategoryId !== null &&
        this.state.subcategoryId !== 0
      ) {
        payload['subCategoryID'] = this.state.subcategoryId;
      }
      let response = await this.getNamesForRedirect(payload);
      console.log('response', response);
      if (response.data.data !== undefined && response.data.data !== null) {
        let redirectData = response.data.data;
        // Redirect to the new category page.
        let url =
          '?subject_id=' +
          this.state.subjectId +
          '&topic_id=' +
          this.state.topicId +
          '&category_id=' +
          this.state.categoryId +
          '&subject_name=' +
          redirectData.subjectName +
          '&topic_name=' +
          redirectData.topicName +
          '&category_name=' +
          redirectData.categoryName;
        if (
          this.state.subcategoryId !== undefined &&
          this.state.subcategoryId !== null &&
          this.state.subcategoryId !== 0
        ) {
          url =
            'SubCategoryDetails' +
            url +
            '&subcategory_id=' +
            this.state.subcategoryId +
            '&subcategory_name=' +
            redirectData.subCategoryName;
        } else {
          url = 'subCategory' + url;
        }

        this.props.setRedirectURL(url);
        this.setState({ loading: false });
      }
    }
  }
  changeExplanationName(e) {
    //console.debug("changeExplanationName",e.target.value);
    var tempExplanationName = e.target.value;
    this.setState({
      ExplanationName: tempExplanationName,
      ExplanationNameDefaultVaule: tempExplanationName
    });
  }


  render() {
    if (this.state.pageLoading) {
      return <LoadingSpinner />;
    }

    let ExplanationWithOutPreviewStyle = {
      float: 'left',
      width: '100%',
      marginLeft: '17',

    };
    let floatFooter = {
      position: 'fixed',
      bottom: '0px',
      width: '100%',
      backgroundColor: 'white',
      float: 'left',
      zIndex: 12,
    };
    let ExplanationWithPreviewStyle = {
     // width: '50%',
      //overflow: 'scroll',
      maxHeight: '90vh',
      marginLeft: '17px'
    };
    let ExplanationWithPreviewWidthStyle = { padding: '0px', marginTop: '35px' };
    let ExplanationWithPreviewSaveBtn = { width: '50%' };
    let showPreviewStyle = {
      float: 'right',
      marginTop: '0px',
      //marginLeft: '623px',
      display: 'block',
      //position: 'absolute',
      //backgroundColor: 'rgb(242, 243, 244)',
      height: '100vh',
     // width: '45%',
      overflow: 'scroll'
    };
    let hidePreviewStyle = {
      float: 'left',
      marginTop: '-0px',
      marginLeft: '750px',
      display: 'none'
    };
    let padding = { paddingLeft: '97px' };
    let paddingZero = { paddingLeft: '0px' };

    let hideDiv = { display: 'none' };

    let ExplanationTextWidth = {};
    var controlEnable = 'disabled';
    console.debug('copyMode', this.props.copyMode);
    if (this.state.copyMode === 1) {
      controlEnable = '';
    }

    const loadingSave = this.state.loadingSave;
    return (
      <form className="formClass">
      <fieldset disabled={this.props.readOnly}>
      <div style={{ width: '100%', overflowY: 'hidden', overflowX: 'hidden' }}>
        <Loader loading={this.state.loading} />
        <div style={styles.createQuesPage}>
          {/*Live Preview Div start*/}
          {/* <div className="livePreviewClass"
            style={
              this.state.isExplanationWithPreview || this.props.showPreview
                ? showPreviewStyle
                : hidePreviewStyle
            }
          >
            <div style={styles.livePreviewTitleDiv}>
              <p style={styles.previewTitle}>Live Preview</p>
              <p style={{ float: 'right' }}>
                <Button className="exitButton"
                  flat
                  primary
                  swapTheming
                  style={styles.buttomClass}
                  onClick={() => {
                    if (this.props.showPreview) {
                        this.props.exitPreview();
                        return;
                    }
                    this.previewExit()
                  }}
                >
                  Exit
                </Button>
              </p>
            </div>
            <div style={styles.livePreviewExplanationDiv}>
              <br />
              <br />
              <div style={styles.previewText}>
                <MathJax
                  math={TextEditor.getHTMLStringFromEditorState(this.state.ExplanationTextEditorObj)}
                />
              </div>
            </div>
            <div>
              <br />

              <div style={styles.previewText}>

              </div>
            </div>
          </div> */}
          {/*Live Preview Div end */}

          {/* New Live Preview UI */}

            {this.state.showLivePreview ? 
              <SFExplanationPreview
                visible={this.state.showLivePreview}
                explanations={this.props.explanation ? [{
                  ...this.props.explanation,
                  text: JSON.stringify(convertToRaw(this.state.ExplanationTextEditorObj.getCurrentContent())),
                  // text: this.state.ExplanationText,
                }] : []}
                selectedRowIndex={0}
                closeLivePreview={() => {
                  this.setState({
                    showLivePreview: false
                  })
                }}
              />
            : null}


              {/* <DialogContainer
                visible={this.state.showLivePreview || this.props.showPreview}
                width={'100%'}
                fullPage={window.innerWidth < 768}
                height={window.innerWidth < 768 ? '100%': '80%'}
                className='explanation-dialog'
                focusOnMount={false}>

                <NavigationDrawer
                  drawerHeader={<div style={{ padding: "20px", background: '#ba0c2f' }}><h2 style={{ color: '#fff' }}>Explanations</h2></div>}
                  navItems={[
                    {
                      primaryText: this.state.ExplanationNameDefaultVaule,
                      active: true,
                      style: { backgroundColor: '#dadbdc', color: '#ba0c2f'},
                    }
                  ]}
                  desktopDrawerType={NavigationDrawer.DrawerTypes.FULL_HEIGHT}
                  includeDrawerHeader={true}

                >

                  <div>
                    
                      <div style={{
                          width: '100%',
                          position: 'relative',
                          height: "500px",
                          overflowY: 'auto',
                      }}>
                         <center className='explanation-div'>
                      <h2 style={{fontWeight:'500'}}>{this.state.ExplanationNameDefaultVaule}</h2>
                    </center>

                      <MathJax math={TextEditor.getHTMLStringFromEditorState(this.state.ExplanationTextEditorObj)}/>
                      </div>
                  </div>
                </NavigationDrawer>
                <div style={{
                    position: 'fixed',
                    bottom: "6px",
                    left: 0,
                    width: '100%',
                    zIndex: 99,
                  }}>

                    <center>
                      <SFButton variant='contained' 
                      style={{
                        background:'#ba0c2f'
                      }}
                      size='small' onClick={() => {
                        this.setState({showLivePreview: false});
                      }}>
                        Close
                      </SFButton>
                    </center>

                  </div>
              </DialogContainer> */}


          {!this.props.showPreview ?
          <div className="livePreviewWithQuestion"
            style={
              this.state.isExplanationWithPreview
                ? ExplanationWithPreviewStyle
                : ExplanationWithOutPreviewStyle
            }
          >
            <h1>Explanation Details Page</h1>

            <div style={{ marginLeft: '17px', float:'left' }}>
              <b>Explanation Name</b>
            </div>
            <br />
            <input
              className="textbox-beautify"
              type="text"
              value={this.state.ExplanationNameDefaultVaule}
              onChange={this.changeExplanationName}
              placeholder="Add New  explanation"
            />
            <Button
              flat
              primary
              swapTheming
              className="buttonStyle"
              /* style={
                this.state.isExplanationWithPreview ? hideDiv : styles.livePreview
              } */
              onClick={() => {
                this.setState({showLivePreview: true})
              }}
            >
              Live Preview
            </Button>

            {this.props.copyMode ? (
              <div style={{ padding: '0px', marginLeft: '0px' }}>
                <br />
                <h4>
                  Please choose a new destination(category or subcategory)
                </h4>
                <Grid>
                  <Cell size={this.state.isExplanationWithPreview ? 4 : 3}>
                    
                    <br />
                    <SelectBox
                    labeltxt="Subjects"
                      columns={this.state.subjects}
                      keys={['subject_id', 'subject_name']}
                      className="create-explanation-select-box"
                      selectBoxcallBack={this.selectBoxSubjectHandleChange}
                      defaultId={this.state.subjectDefaultId}
                      selectBoxDisabled={controlEnable}
                    />
                  </Cell>
                  <Cell
                    style={
                      this.state.isExplanationWithPreview ? padding : paddingZero
                    }
                    size={this.state.isExplanationWithPreview ? 4 : 3}
                  >
                    
                    <br />
                    <SelectBox
                      labeltxt="Topics"
                      columns={this.state.topics}
                      keys={['topic_id', 'topic_name']}
                      className="create-explanation-select-box"
                      selectBoxcallBack={this.selectBoxTopicHandleChange}
                      defaultId={this.state.topicDefaultId}
                      selectBoxDisabled={controlEnable}
                      ///bug-tracker#156
                      style={{
                        visibility: this.state.showTopicsSelectBox
                          ? 'visible'
                          : 'hidden'
                      }}
                    />
                  </Cell>
                  <Cell size={this.state.isExplanationWithPreview ? 6 : 3}>
                    
                    <br />
                    <SelectBox
                    labeltxt="Category"
                      columns={this.state.categories}
                      keys={['category_id', 'category_name']}
                      className="create-explanation-select-box"
                      selectBoxcallBack={this.selectBoxCategoryHandleChange}
                      defaultId={this.state.categoryDefaultId}
                      ///bug-tracker#156
                      style={{
                        visibility: this.state.showCategorySelectBox
                          ? 'visible'
                          : 'hidden'
                      }}
                      selectBoxDisabled={controlEnable}
                    />
                  </Cell>
                  <Cell size={this.state.isExplanationWithPreview ? 4 : 3}>
                    
                    <br />
                    <SelectBox
                    labeltxt="SubCategory"
                      columns={this.state.subCategories}
                      keys={['subcategory_id', 'subcategory_name']}
                      className="create-explanation-select-box"
                      selectBoxcallBack={this.selectBoxSubcategoryHandleChange}
                      defaultId={this.state.subCategoryDefaultId}
                      ///bug-tracker#156
                      style={{
                        visibility: this.state.showSubCategorySelectBox
                          ? 'visible'
                          : 'hidden'
                      }}
                      selectBoxDisabled={controlEnable}
                    />
                  </Cell>
                </Grid>
              </div>
            ) : (
              ''
            )}
            <div>

            </div>
            <div style={{ width: '100%' }}>
              <Grid >
                <Cell size={this.state.isExplanationWithPreview ? 12 : 12}>
                  <div
                    style={
                      this.state.isExplanationWithPreview
                        ? ExplanationTextWidth
                        : paddingZero
                    }
                  >
                    <TextEditor
                      value={this.state.ExplanationTextEditorObj}
                      onChange={this.onExplanationTextChange}
                      name='ExplanationEditor'
                      video = "true"
                      className="custom-text-editor"
                    /><br/>
                    <div     style={(this.state.altExplanationTextVisible ?{width : "63%", marginLeft: "5%"} : {display:"none"})}>
                <tr><td><p style={{fontSize:"medium",color: '#960000'}}><label for="altexpId">
                  Title and Alternative Text for all Images in Explanation </label></p></td>
                <td><Button className='nocqcStyle' icon tooltipLabel="Format : Title Text for 1st Image ; Alt text 1st Image ; Title Text for 2nd Image ; Alt text for 2nd Image and so on. Don't use semicolon at the end of the text. Use it only to separate Title and Alt Text.">help</Button></td></tr>
               
                <TextField
                id="altexpId"
                style={ {borderStyle: "ridge"}}
                rows={2}
                value={this.state.altExplanationTextEditorObj}
                onChange={this.onAltExplanationTextChange}
                name='altQuestionEditor'
                />
                </div>
                  </div>
                </Cell><br/>
                <Cell>
               
                </Cell>
              </Grid>

            </div>

            <div
              style={
                this.state.isExplanationWithPreview
                  ? ExplanationWithPreviewWidthStyle
                  : ExplanationWithOutPreviewStyle
              }
            >
              {/*Answers list div*/}
              <br />

              <ImageResizeWarning />

            </div>
          </div>
          : null}

          {!this.props.showPreview ?

          <div
            style={
              this.state.isExplanationWithPreview
                ? ExplanationWithPreviewSaveBtn
                : ExplanationWithOutPreviewStyle
            }
          >


          <div style = {floatFooter}>

            <center>
              {/* bug id 145  fixes*/}
              {loadingSave ? (
                <LoadingSpinner cls="" />
              ) : this.props.readOnly?null: (
                <div>
                  <Button
                  style={this.props.currSubject ? {}  : {display:"none"}}
                    flat
                    primary
                    swapTheming
                    onClick={
                      this.state.copyMode
                        ? () => this.copyExplanation(false)
                        : () =>
                            this.addExplanation(
                              this.props.selectedExplanationId,
                              this.state.subjectId,
                              this.state.topicId,
                              this.state.categoryId,
                              this.state.subcategoryId,
                              false
                            )
                    }
                  >
                    Save
                  </Button>
&nbsp;&nbsp;&nbsp;
                  <Button
                    flat
                    tertiary = "true"
                    swapTheming
                    style={this.props.currSubject ? {backgroundColor: "green",color: "white"} : {display:"none"}}
                    onClick={
                      this.state.copyMode
                        ? () => this.copyExplanation(true)
                        : () =>
                            this.addExplanation(
                              this.props.selectedExplanationId,
                              this.state.subjectId,
                              this.state.topicId,
                              this.state.categoryId,
                              this.state.subcategoryId,
                              true
                            )
                    }
                  >
                    Save & Close
                  </Button>
                  &nbsp;&nbsp;&nbsp;
                  <Button flat secondary swapTheming onClick={this.props.close}>
                    Close
                  </Button>

                </div>
              )}

            </center>

            </div>
          </div>
          : null}

        </div>
      </div>
      </fieldset>
      </form>
    );
  }
}
